import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LanguageService } from "./../language.service";
import { CommonModule } from '@angular/common';
import { IosCheckerService } from "./../ios-checker.service";

@Component({
  selector: 'app-portfolio',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './portfolio.component.html',
  styleUrl: './portfolio.component.scss'
})
export class PortfolioComponent implements OnInit {
  @ViewChild('songPlayer') songPlayer?: ElementRef<HTMLAudioElement>;

  listenText: string = '';
  showColored: boolean = false;
  isIOS:boolean = false; 
  isSongListOpen: boolean = false;
  selectedSongIndex: number = 0;
  songs = [
    { title: 'Bullit', src: 'assets/songs/01_Bullit.mp3' },
    { title: 'Final Homework', src: 'assets/songs/02_Final Homework.mp3' },
    { title: 'Goin\' Home', src: 'assets/songs/03_Goin_ Home.mp3' },
    { title: 'Number of Samba', src: 'assets/songs/04_Number of Samba.mp3' },
    { title: 'Not From Here', src: 'assets/songs/05_Not From Here.mp3' },
    { title: 'Come As You Are', src: 'assets/songs/06_Come As You Are.mp3' },
    { title: 'Deeper Underground', src: 'assets/songs/07_Deeper Underground.mp3' },
    { title: 'Iron Man', src: 'assets/songs/08_Iron Man.mp3' },
    { title: 'Just Dropped In', src: 'assets/songs/09_Just Dropped In.mp3' }
  ];

  constructor(private languageService: LanguageService, private http: HttpClient, private iosChecker: IosCheckerService) {
    this.isIOS = this.iosChecker.isUserIOS();
   }
   
  ngOnInit(): void {
    this.languageService.getCurrentLanguage().subscribe(lang => {
      this.onLanguageChange(lang);
    })
  }

  onLanguageChange(lang: string): void {
    this.loadText(lang);
  }

  loadText(lang: string): void {
    this.http.get<any>('assets/text-data.json').subscribe(data => {
      this.listenText = data[lang]['listenText'];
    });
  }

  toggleSongList(): void {
    this.isSongListOpen = !this.isSongListOpen;

    if (this.isSongListOpen) {
      this.playSong(this.selectedSongIndex);
    } else {
      this.songPlayer?.nativeElement.pause();
    }
  }

  openSongList(): void {
    if (!this.isSongListOpen) {
      this.isSongListOpen = true;
      this.playSong(this.selectedSongIndex);
    }
  }

  closeSongList(event?: Event): void {
    event?.stopPropagation();
    this.isSongListOpen = false;
    this.songPlayer?.nativeElement.pause();
  }

  playSong(index: number): void {
    this.selectedSongIndex = index;

    setTimeout(() => {
      const player = this.songPlayer?.nativeElement;
      if (!player) {
        return;
      }

      player.load();
      player.play().catch(() => undefined);
    });
  }
}
